import { Countdown } from '@app/components/countdown';
import { SwitchCard } from '@app/components/form/SwitchCard';
import { publishMessages } from '@app/modules/social-export/publish';
import { Alert, Box } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';

/** Publish-now vs schedule toggle; reveals the date picker when scheduling. */
export function SocialPublishAtField() {
  const { $t } = useIntl();
  const { control, setValue } = useFormContext();
  const publishAt = useWatch({ control, name: 'publishAt' });
  const publishImmediately = publishAt === null || publishAt === undefined;

  return (
    <Box>
      <SwitchCard
        checked={publishImmediately}
        onChange={(checked) => {
          if (checked) {
            setValue('publishAt', null);
          } else {
            // Default to 1 hour from now when switching to scheduled publish
            const futureDate = new Date();
            futureDate.setHours(futureDate.getHours() + 1);
            setValue('publishAt', futureDate.toISOString());
          }
        }}
        label={$t({
          id: 'socialExport.form.publishImmediately',
          defaultMessage: 'Publicar inmediatamente',
        })}
        description={$t(publishMessages.publishImmediatelyDescription)}
      />
      {!publishImmediately && (
        <Box my={3}>
          <Controller
            name="publishAt"
            control={control}
            render={({ field, fieldState }) => {
              const minDateTime = DateTime.now().plus({ minutes: 2 });

              return (
                <DateTimePicker
                  label={$t({
                    id: 'socialExport.form.publishDateLabel',
                    defaultMessage: 'Fecha y hora de publicación',
                  })}
                  value={field.value ? DateTime.fromISO(field.value) : null}
                  onChange={(newValue: DateTime | null) => {
                    field.onChange(newValue?.isValid ? newValue.toISO() : null);
                  }}
                  minDateTime={minDateTime}
                  slotProps={{
                    textField: {
                      error: !!fieldState.error,
                      helperText: fieldState.error?.message,
                      fullWidth: true,
                    },
                  }}
                />
              );
            }}
          />
          <Countdown value={publishAt} />
        </Box>
      )}
      <Alert severity="info" sx={{ mt: 2 }}>
        {$t(publishMessages.postPublishProcessingNotice)}
      </Alert>
    </Box>
  );
}
